export default __webpack_public_path__ + "static/media/IMG4002.650be0f6.jpg";